import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import MessageList from "./MessageList";
import MessageListToolbar from "./MessageListToolbar";
import InboxEmptyState from "./InboxEmptyState";
import { getAppData, searchMessages } from "../api/InboxApi";
import RuleAction from "../actions/RuleAction";
import UserAction from "../actions/UserAction";
import { fromJS } from "immutable";
import { addDays, format, isSameDay } from "date-fns";
import { useQuery } from "@tanstack/react-query";

export const InboxApp = () => {
  const dispatch = useDispatch();
  const { projectId } = useParams();
  const [inboxApp, setInboxApp] = useState<any>(fromJS({}));
  const [currentDate, setCurrentDate] = useState<Date>(new Date());
  const currentUser = useSelector((state: any) => state.userReducer.get("currentUser"));

  const currentAppId = currentUser.get("currentInboxAppId") || "google";
  const types = ["GMAIL"];

  const startDate = addDays(currentDate, -3);

  const dateRangeDisplay = `${format(startDate, "EEEE, MMM d")} - ${format(currentDate, "MMM d")}`;

  const startDateStr = `${format(addDays(currentDate, -3), "yyyy-MM-dd")} 00:00:00`;
  const endDateStr = `${format(currentDate, "yyyy-MM-dd")} 23:59:59`;

  const { data = { content: [] }, isPending } = useQuery({
    queryKey: ["searchMessages"],
    queryFn: () =>
      searchMessages({
        types,
        filters: {
          start: {
            operator: "dateRange",
            values: [startDateStr, endDateStr],
          },
        },
      }),
  });

  useEffect(() => {
    if (currentAppId) {
      getAppData(currentAppId).then((result) => {
        setInboxApp(fromJS(result.data));
      });
    }
  }, [currentAppId]);

  useEffect(() => {
    dispatch(RuleAction.getAppLinks());
  }, [dispatch]);

  const handleSelectApp = (appId) => {
    dispatch(UserAction.updateCurrentUserSetting({ currentInboxAppId: appId }));
  };

  const renderMessageList = () => {
    if (!inboxApp.get("connected")) {
      return <InboxEmptyState projectId={projectId} appId={currentAppId} />;
    }
    return <MessageList messages={fromJS(data.content)} loading={isPending} />;
  };

  return (
    <div className={"w-full"}>
      <MessageListToolbar
        dateRangeDisplay={dateRangeDisplay}
        isToday={isSameDay(currentDate, new Date())}
        onToday={() => {
          setCurrentDate(new Date());
        }}
        onPrev={() => {
          const date = addDays(currentDate, -3);
          setCurrentDate(date);
        }}
        onNext={() => {
          const date = addDays(currentDate, 3);
          setCurrentDate(date);
        }}
        appId={currentAppId}
        handleSelectApp={handleSelectApp}
      />
      {renderMessageList()}
    </div>
  );
};

export default InboxApp;
